import React, { useState, useEffect } from 'react'
import api from '../../../../Services/api';
import axios from 'axios';
import { Bar } from 'react-chartjs-2';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import LcrReport from './lcrReport';
import { useNavigate } from 'react-router-dom';
import ChartDataLabels from 'chartjs-plugin-datalabels';  
 import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
    ArcElement
    } from 'chart.js';

    ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend, ArcElement,ChartDataLabels);
    const months = [
        { name: "JANUARY", value: "01" },
        { name: "FEBRUARY", value: "02" },
        { name: "MARCH", value: "03" },
        { name: "APRIL", value: "04" },
        { name: "MAY", value: "05" },
        { name: "JUNE", value: "06" },
        { name: "JULY", value: "07" },
        { name: "AUGUST", value: "08" },
        { name: "SEPTEMBER", value: "09" },
        { name: "OCTOBER", value: "10" },
        { name: "NOVEMBER", value: "11" },
        { name: "DECEMBER", value: "12" }
    ];

const VendorsMonthlyData = () => {
    let data1 = sessionStorage.getItem('user');
    let clientData = JSON.parse(data1);
    let id = clientData.id;
    const currentYear = new Date().getFullYear();
    const navigate = useNavigate()
    const years = Array.from({ length: currentYear - 2020 + 1 }, (x, i) => 2020 + i);
    const [vendorOptions, setVendorOptions] = useState([]);
    const[selectedVendor, setSelectedVendor] = useState('');
    const [selectedYear, setSelectedYear] = useState(currentYear);
        const [selectedQuarter, setSelectedQuarter] = useState('');
        const [snackbarOpen, setSnackbarOpen] = useState(false);
          const [snackbarMessage, setSnackbarMessage] = useState('');
          const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
          const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
       
        
  const [chartData, setChartData] = useState({
        labels: [],
        datasets: [
        {
            label: 'Accepted',
            data: [],
            backgroundColor: '#50c878',
        },
        {
            label: 'Rejected',
            data: [],
            backgroundColor: '#B22222',
        },
        {
            label: 'UnderReview',
            data: [],
            backgroundColor: '#EFCC00',
        }
        ]
    });
    const handleQuarterChange = (e) => {
        setSelectedQuarter(e.target.value);
    };
    useEffect(() => {
   
    fetchVendors();
    }, [id]);

    const fetchVendors = async () => {
        try {
        const response = await api.client.getAllVendors(id);
     
        if(response.status === 200){
        setVendorOptions(response.data.data.vendorProfile || []);
        }
        else if(response.status === 404)
        {
            setErrorSnackbarOpen(true)
            setSnackbarErrorMessage(response.data.message);
            setVendorOptions([])
        }
        else if(response.status === 400){
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage(response.data.message)
            setVendorOptions([])
        }
        else{
            setErrorSnackbarOpen(true);
            setSnackbarErrorMessage("Unable to fetch details, please try again")
            setVendorOptions([])
        }
    }
    catch(error){
        console.error("Error in fetching the data",error)
    }
}
    const handleVendorChange = (event) =>{
const {value} = event.target;
setSelectedVendor(value);
    }
    const handleYearChange = (event) => {
        setSelectedYear(event.target.value);
    };
  
    const getQuarterMonths = (quarter) => {
        switch (quarter) {
        case 'Q1':
            return [0, 1, 2];
        case 'Q2':
            return [3, 4, 5]; 
        case 'Q3':
            return [6, 7, 8]; 
        case 'Q4':
            return [9, 10, 11]; 
        default:
            return [];
        }
    };
    useEffect(() => {
        if (snackbarMessage) {
            setSnackbarOpen(true); 
        } else {
            setSnackbarOpen(false);  
        }
    }, [snackbarMessage]); 
    
    useEffect(() => {
        if (snackbarErrorMessage) {
            setErrorSnackbarOpen(true);  
        } else {
            setErrorSnackbarOpen(false); 
        }
    }, [snackbarErrorMessage]); 


    useEffect(() => {
        if (selectedVendor && selectedVendor !== "select") {
            fetchVendorMonthlyData(selectedVendor, selectedYear, selectedQuarter);
        }
    }, [selectedVendor, selectedYear, selectedQuarter]);

    useEffect(() => {
        if (vendorOptions.length > 0 && !selectedVendor) {
            const firstVendorId = vendorOptions[0].vendorId; 
            setSelectedVendor(firstVendorId);
        }
    }, [vendorOptions, selectedVendor]); 

   
    const handleBarClick = ({ status, monthLabel, year ,vendorId}) => {
        sessionStorage.setItem('selectedVendorId',vendorId)
        sessionStorage.setItem('status',status)
        console.log(monthLabel,"month")
        navigate('/vendors-monthlyData', {
            state: {
                filter: status,
                month: monthLabel < 10 ? `0${monthLabel}` : `${monthLabel}`,  // e.g., 05
                year,
                vendorId
              },
        })
        
      };


      const fetchVendorMonthlyData = async (vendorId, year, quarter = '') => {
        try {
        const response = await axios.get(`https://www.grcpulse.in/api/monthlydata/yearly/${vendorId}`, {
            params: { year }
        });
       if(response.status === 200){
        const data = response.data.data;
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        console.log("mothlydata",data);
        const quarterMonths = quarter ? getQuarterMonths(quarter) : [...Array(12).keys()];

        const acceptedPercent = [];
        const rejectedPercent = [];
        const underReviewPercent = [];
        const monthLabels = [];
 
        quarterMonths.forEach((monthIndex) => {
            const monthData = data.find(item => item.month === (monthIndex + 1).toString().padStart(2, '0'));
            monthLabels.push(months[monthIndex]);
            if (monthData) {
            acceptedPercent.push(monthData.AcceptedPercent || 0);
            rejectedPercent.push(monthData.RejectedPercent || 0);
            underReviewPercent.push(monthData.UnderReviewPercent || 0);
            } else {
            acceptedPercent.push(0);
            rejectedPercent.push(0);
            underReviewPercent.push(0);
            }
        });

        setChartData({
            labels: monthLabels,
            datasets: [
            {
                label: 'Accepted',
                data: acceptedPercent,
                backgroundColor: '#50c878',
                 barThickness: 12,
            },
            {
                label: 'Rejected',
                data: rejectedPercent,
                backgroundColor: '#B22222',
                 barThickness: 12,
            },
            {
                label: 'UnderReview',
                data: underReviewPercent,
                backgroundColor: '#EFCC00',
                 barThickness: 12,
            }
            ]
        });
        } 
        else if(response.status === 404)
            {
           setErrorSnackbarOpen(true);
           setSnackbarErrorMessage(response.data.message)
            }
            else if(response.status === 400){
                setErrorSnackbarOpen(true);
           setSnackbarErrorMessage(response.data.message)
            }
            else if(response.status === 500){
                setErrorSnackbarOpen(true);
           setSnackbarErrorMessage(response.data.message)
            }
            else{
                setErrorSnackbarOpen(true);
                setSnackbarErrorMessage('Some error occured, please try again later');
            }
       
    
   
    }catch (error) {
        console.error("Error fetching monthly data:", error);
        }
    };
    return (
        <div>
  <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        severity="success"
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackbarOpen(false)}
        sx={{ marginTop: '2.9%', marginRight: '7%' }}
      >
        <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
      </Snackbar>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        severity="error"
        open={errorSnackbarOpen}
        autoHideDuration={2000}
        sx={{ marginTop: '2.9%', marginRight: '7%' }}
        onClose={() => setErrorSnackbarOpen(false)}
      >
        <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
      </Snackbar>
    
     
            
                    <div  style={{border:'1px solid lightgray',height:"380px"}}>
                    <h6 className='pt-3 pb-3 px-3 bg-dark text-light text-center'>Vendor Monthly Compliance</h6>
      <section className='pt-3 pb-2 px-2 d-flex float-end'>
       
<select className='p-1' value={selectedVendor} onChange={handleVendorChange} style={{borderRadius:'4px',width:'200px',border:'1px solid lightgray',maxWidth:'250px', cursor:'pointer'}}>
              <option value="" disabled>Select Vendor</option>
              {vendorOptions && vendorOptions.length > 0 ? (
                vendorOptions.map(vendor => (
                  <option key={vendor.vendorId} value={vendor.vendorId}>
                      {vendor.vendorCompanyName}, {vendor.vendorStateId}
                  </option>
              ))):(
                <div></div>
              )}
          </select>
          <select  className='p-1 mx-2' onChange={handleQuarterChange} style={{border:'1px solid lightgray',borderRadius:'4px', cursor:'pointer'}} value={selectedQuarter}>
                <option value="">All Months</option> 
                <option value="Q1">Q1</option>
                <option value="Q2">Q2</option>
                <option value="Q3">Q3</option>
                <option value="Q4">Q4</option>
                </select>
          <select className='p-1' style={{border:'1px solid lightgray',borderRadius:'4px', cursor:'pointer'}} value={selectedYear || ''} onChange={handleYearChange} >
                    <option value="" disabled>Select Year</option>
                    {years.map((year) => (
                        <option key={year} value={year}>
                            {year}
                        </option>
                    ))}
                </select>
               </section>
                            <Bar
                          
                                data={chartData}
                                options={{
                                    onHover: (event, chartElement) => {
                                        event.native.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
                                      
                                      },
                                    onClick: (event, elements, chart) => {
                                        if (elements.length > 0) {
                                          const chartElement = elements[0];
                                          const datasetIndex = chartElement.datasetIndex;
                                          const dataIndex = chartElement.index;
                                  
                                          const status = chartData.datasets[datasetIndex].label;
                                          const monthLabel = dataIndex + 1;
                                          const vendorId = selectedVendor;
                                          const year = selectedYear; 
                                        console.log(monthLabel,"monthbe");
                                  handleBarClick({status,monthLabel,vendorId,year})
                                  
                                        }
                                    },
                                responsive: true,
                                plugins: {
                                    legend: { display:false},
                                    tooltip: { enabled: true,
                                        callbacks: {
                                            label: function (tooltipItem) {
                                                const percentageValue = tooltipItem.raw;
                                                const datasetLabel = tooltipItem.dataset.label; // Get the label of the dataset
                                                let status = '';
                        
                                                // Determine the status based on the dataset label
                                                if (datasetLabel === 'Accepted') {
                                                    status = 'Accepted';
                                                } else if (datasetLabel === 'Rejected') {
                                                    status = 'Rejected';
                                                } else if (datasetLabel === 'UnderReview') {
                                                    status = 'Under Review';
                                                }
                        
                                                // Return the status with the percentage
                                                return `${status}: ${percentageValue}%`;
                                            }
                                          }
                                     },
                                    datalabels: {
                                        display: false
                                },
                                },
                               
                                scales: {
                                    x: {
                                    title: { display: true },
                                    ticks: { color: 'gray' },
                                    borderColor: '#1c1c1c',
                                    borderWidth: 2,
                                    grid: { display: false },
                                    
                                   
                                
                                    },
                                    y: {
                                    title: { display: true},
                                    min: 0,
                                    max: 100,
                                   
                                    ticks: {  stepSize: 15, color: 'gray', callback: value => value + '%' },
                                    borderColor: '#1c1c1c',
                                    borderWidth: 2,
                                    grid: { display: false }
                                    }
                                }
                                }}
                            />
                            </div>
             
                           
        </div>

    )

}
export default VendorsMonthlyData;

